<template>
  <div class="hero-container">
    <Carousel class="hero" v-bind="config">
      <Slide v-for="banner in banners" :key="banner.id">
        <div
          v-if="useLowerCase(banner.file_type) === 'video'"
          class="hero-video-container"
        >
          <a
            :href="banner.url || ''"
            :target="banner.url?.startsWith('http') ? '_blank' : ''"
          >
            <video
              autoplay
              muted
              loop
              playsinline
              class="hero-video"
              :poster="banner.image_url || ''"
            >
              <source :src="banner.image_url" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </a>
        </div>

        <div v-else class="hero-image-container">
          <a
            :href="banner.url || ''"
            :target="banner.url?.startsWith('http') ? '_blank' : ''"
          >
            <NuxtImg
              :src="
                isMobile && banner.image_url_xs
                  ? banner.image_url_xs + '?auto=format,compress&fm=webp&q=75'
                  : banner.image_url  + '?auto=format,compress&fm=webp&q=75'
              "
              :modifiers="{ format: 'webp' }" 
              :alt="banner.name"
              class="hero-image"
            />
          </a>
        </div>
      </Slide>

      <template #addons v-if="banners.length > 1">
        <Navigation class="hero-navigator" />
        <Pagination class="hero-paginator" />
      </template>
    </Carousel>
  </div>
</template>

<script setup>
import { useMainStore } from "~/store/index";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
const store = useMainStore();
await store.ensureMMData("homepage");

const { isMobile } = useMobileChecker();

// *** CAROUSEL CONFIG *** //
const config = {
  height: 350,
  itemsToShow: 1,
  gap: 0,
  clamp: true,
  dir: "ltr",
  breakpointMode: "viewport",
};

const banners = store.homepageData?.banners?.[0]?.gallery_items || [];
</script>

<style scoped lang="scss">
.hero-video {
  border-radius: 0px;
  width: 107%;
  height: 100%;
  object-fit: cover;
  object-position: center; // centers the video
  display: block;
  z-index: -1;
}

.hero-image {
  border-radius: 0px;
  width: 100vw;
  height: 100%;
  object-fit: cover;
}

.carousel .carousel__pagination {
  position: relative;
  bottom: 40px !important;
}

.hero-paginator {
  .carousel__pagination-button {
    &::after {
      background-color: grey !important;
    }
  }
}
</style>
